// TODO: These should eventually be pulling from our design system library
var HEADING_SIZES = {
  h1: {
    base: '2.625rem',
    fontWeight: '300'
  },
  h2: {
    base: '2.0625rem',
    fontWeight: '300',
    letterSpacing: '.1px'
  },
  h3: {
    base: '1.75rem',
    fontWeight: '400'
  },
  h4: {
    base: '1rem',
    fontWeight: '500',
    letterSpacing: '0.15px',
    lineSpacing: '19px'
  },
  h5: {
    base: '1rem',
    fontWeight: '500',
    letterSpacing: '0.15px',
    lineSpacing: '19px'
  },
  h6: {
    base: '1rem',
    fontWeight: '500',
    letterSpacing: '0.15px',
    lineSpacing: '17px'
  }
};

export { HEADING_SIZES };
